module.exports = __webpack_public_path__ + "img/v4_trade5.c3611b67.png";